import { z } from 'zod'

import type { Student } from '~/@entities/Student'
import type { CommonResponseListString, CommonResponseString } from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import { ScenarioLatestStudentIdSchema, type ScenarioUnitId, ScenarioUnitIdSchema } from './schemas'

const ENTITY = 'Scenario'

export const adaptScenarioUnitIds = (raw: CommonResponseListString['data']): ScenarioUnitId[] =>
  parseApiResponse(z.array(ScenarioUnitIdSchema), raw, ENTITY)

// 생성 타입은 data 를 optional 로 그리지만 서버(CommonResponse<String?>)는 학생이 없으면 키를 빼지 않고 null 을 싣는다.
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 scenario/controller/ScenarioUnitActionLogController.kt·common/CommonResponse.kt 로 확인.
const asWire = (raw: CommonResponseString['data']): unknown => raw

export const adaptScenarioLatestStudentId = (
  raw: CommonResponseString['data'],
): Student['id'] | null => parseApiResponse(ScenarioLatestStudentIdSchema, asWire(raw), ENTITY)
